import React, {
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
} from 'react'

// import { StargazerConnector } from '@stardust-collective/web3-react-stargazer-connector'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'
import { WalletConnectV2Connector } from '../connectors/WalletConnectV2Connector'

type ContextType = {
  library?: any
  account?: any
  connect?: any
  connector?: any
  disconnect?: any
  chainId?: any
  network?: any
}

const Context = React.createContext<ContextType>({})

const POLLING_INTERVAL = 12000
const RPC_URLS = {
  1: import.meta.env.VITE_RPC_URL_1,
  3: import.meta.env.VITE_RPC_URL_3,
  5: import.meta.env.VITE_RPC_URL_5,
  42: import.meta.env.VITE_RPC_URL_42,
}
const SUPPORTED_CONNECTORS = ['injected', 'walletconnect', 'stargazer']

export const injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 1337],
})

export const walletconnect = new WalletConnectV2Connector({
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'demo-project-id',
  chains: [1, 3, 4, 5, 42, 1337],
  rpcMap: RPC_URLS as any,
  showQrModal: true,
})

// export const stargazerConnector = new StargazerConnector({
//   supportedChainIds: [
//     1,
//     5, // Ethereum Goerli Testnet
//   ],
// })

export const resetWalletConnector = (connector: any) => {
  if (connector && connector instanceof WalletConnectV2Connector) {
    // For WalletConnect v2, we can call close() to reset
    connector.close()
  }
}

const networks = {
  1: 'Mainnet',
  4: 'Rinkeby',
  3: 'Ropsten',
  5: 'Goerli',
  42: 'Kovan',
}

export function UserWalletProvider({ children }: { children: ReactNode }) {
  const { connector, account, activate, deactivate, chainId, library, ...r } =
    useWeb3React()

  useEffect(() => {
    const connected = localStorage.getItem('connected')

    if (connected === 'injected') {
      activate(injected)
    } else if (connected === 'walletconnect') {
      activate(walletconnect)
    } 
    // else if (connected === 'stargazer') {
    //   activate(stargazerConnector)
    // }
  }, [activate])

  const connect = useCallback(
    async (type: string) => {
      if (!SUPPORTED_CONNECTORS.includes(type)) {
        return
      }

      if (type === 'walletconnect') {
        await activate(walletconnect)
        localStorage.setItem('connected', 'walletconnect')
      } 
      // else if (type === 'stargazer') {
      //   await activate(stargazerConnector)
      //   localStorage.setItem('connected', 'stargazer')
      // } 
      else if (type === 'injected') {
        await activate(injected)
        localStorage.setItem('connected', 'injected')
      }
    },
    [activate],
  )

  const disconnect = useCallback(async () => {
    await deactivate()
    localStorage.setItem('connected', 'n')
  }, [deactivate])

  const contextValue = useMemo(
    () => ({
      library,
      account: account?.toLowerCase(),
      connect,
      disconnect,
      chainId,
      network: networks[1],
      connector,
    }),
    [account, chainId, connect, connector, disconnect, library],
  )

  return <Context.Provider value={contextValue}>{children}</Context.Provider>
}

export default Context

export const useUserWallet = () => {
  return useContext(Context)
}
